import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}employee-salaries/`;

export default {
  list(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  create(payload) {
    return axios.post(API_URL, payload, { headers: buildHeaders() });
  },
  show(id, params = {}) {
    return axios.get(`${API_URL}${id}`, { params, headers: buildHeaders() });
  },
  update(id, payload) {
    return axios.put(`${API_URL}${id}`, payload, { headers: buildHeaders() });
  },
  destroy(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  getPayrollAdjustments(employeeId, period) {
    return axios.get(`${API_URL}payroll-adjustments`, {
      params: { employee_id: employeeId, period },
      headers: buildHeaders(),
    });
  },

  savePayrollAdjustments(payload) {
    return axios.put(`${API_URL}payroll-adjustments`, payload, {
      headers: buildHeaders(),
    });
  },

  // async fetchLoansSavingsReport(params) {
  //   const { data } = await api.get("/reports/loans-savings", { params });
  //   return data;
  // },
  // async exportLoansSavingsReport(format, params) {
  //   const { data } = await api.get("/reports/loans-savings/export", {
  //     params: { ...params, format },
  //     responseType: "blob",
  //   });

  //   // download helper (use your existing one if you have it)
  //   const filename = `loans-savings-report.${format === "pdf" ? "pdf" : "csv"}`;
  //   const blob = new Blob([data]);
  //   const link = document.createElement("a");
  //   link.href = window.URL.createObjectURL(blob);
  //   link.download = filename;
  //   link.click();
  // },

  async getLoanSavingsMetaHint(employeeId, period) {
    return axios.get(`${API_URL}hrm/payroll/meta-status`, {
      params: { employee_id: employeeId, period },
      headers: buildHeaders(),
    });
  },
};
